const ACCESS_TOKEN_STORAGE_KEY = 'zoofizjo_authorization_token';
const REFRESH_TOKEN_STORAGE_KEY = 'zoofizjo_refresh_token';
const ACTIVE_WORKSPACE_STORAGE_KEY = 'zoofizjo_active_workspace';

export const UNAUTHORIZED_EVENT_NAME = 'zoofizjo:unauthorized';
export const SESSION_EXPIRED_EVENT_NAME = 'zoofizjo:session-expired';

export function readActiveWorkspaceSelection(): string {
  const stored = window.localStorage.getItem(ACTIVE_WORKSPACE_STORAGE_KEY);
  if (stored === null) {
    return '';
  }
  return stored;
}

export function storeActiveWorkspaceSelection(selection: string): void {
  window.localStorage.setItem(ACTIVE_WORKSPACE_STORAGE_KEY, selection);
}

export function clearActiveWorkspaceSelection(): void {
  window.localStorage.removeItem(ACTIVE_WORKSPACE_STORAGE_KEY);
}

export function readStoredAccessToken(): string {
  const storedToken = window.localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY);
  if (storedToken === null) {
    return '';
  }
  return storedToken;
}

export function hasStoredAccessToken(): boolean {
  return readStoredAccessToken().length > 0;
}

export function readStoredRefreshToken(): string {
  const storedToken = window.localStorage.getItem(REFRESH_TOKEN_STORAGE_KEY);
  if (storedToken === null) {
    return '';
  }
  return storedToken;
}

export function storeAuthenticationTokens(accessToken: string, refreshToken: string): void {
  window.localStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, accessToken);
  window.localStorage.setItem(REFRESH_TOKEN_STORAGE_KEY, refreshToken);
}

export function clearAuthenticationTokens(): void {
  window.localStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
  window.localStorage.removeItem(REFRESH_TOKEN_STORAGE_KEY);
}
